import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Box, Button, Checkbox, Container, FlashbarProps, Form, FormField, Link, SpaceBetween, TimeInput } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAirplaneLanding, mdiAirplaneTakeoff } from '@mdi/js';
import Icon from '@mdi/react';
import DPModal from '../../../../components/DPModal';
import Favorites from '../../../../components/extras/Favorites';
import SelectBelt from '../../../../components/selects/SelectBelt';
import SelectGate from '../../../../components/selects/SelectGate';
import SelectStatus from '../../../../components/selects/SelectStatus';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { ItemFlight } from '../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getAirport, getCookie, getDate, getTime, getUrlVersion, setData, setLoading, setParameters } from '../../../commons/functions';

export const FlightsEditPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [direction, setDirection] = useState("")
    const [messages, setMessages] = useState<FlashbarProps.MessageDefinition[]>([]);
    const [flight, setFlight] = useState<ItemFlight>({} as ItemFlight);
    const { data, parameters, idAirport, menu } = useGlobalState();


    const handleUpdateFlight = async () => { // Make the function async    
        try {
            setLoading(true)

            const payload = {
                idFlight: flight.idFlight,
                idStatus: flight.idStatus,
                idGate: flight.idGate,
                idBelt: flight.idBelt,
                departureTimeReal: flight.departureTimeReal,
                arrivalTimeReal: flight.arrivalTimeReal,
                boardingTimeReal: flight.boardingTimeReal,
                isActive: flight.isActive,
                isClosed: flight.isClosed,
                isCancel: flight.isCancel,
                isRMSEnabled: flight.isRMSEnabled,
                isStatusUpdate: flight.isStatusUpdate,
                date: flight.departureTimeReal !== "" ? getDate(flight.departureTimeReal) : (flight.arrivalTimeReal !== "")
            };
            console.log(payload);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/flights/update',
                },
                body: JSON.stringify(payload),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                addNotification(dataWeb.status, "success", setData);
                window.location.hash = "#flights/grid";
            }
        } catch (error: any) {
            setMessages([
                {
                    type: 'error',
                    content: `Error al contactar el servidor: ${error.message}`,
                    id: 'server-error',
                },
            ]);
        } finally {
            setLoading(false)
        }
    };
    const handleGetFlight = async () => { // Make the function async

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/flights/get',
                },
                body: JSON.stringify({
                    idFlight: parameters.idFlight
                }),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                if (!dataWeb.flight.idFlight) {
                    window.location.hash = "#flights/grid";
                    addNotification(`Vuelo no encontrado [ID ${parameters.idFlight}]`, "error", setData);
                } else {
                    setFlight(dataWeb.flight);
                    console.log(getDate(dataWeb.flight.arrivalTimeReal));
                }
            }
        } catch (error: any) {
            addNotification("Error al contactar el servidor: " + error.message, "error", setData);
        } finally {
            setLoading(false)
        }
    };
    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");
            if (id)
                setParameters({ ...parameters, idFlight: parseInt(id) });
            //handleGetEmail(id ? parseInt(id) : 0);
            //else
            //setMailTemplate(undefined);
        };

        window.addEventListener("hashchange", handleHashChange);
        // also trigger once on mount
        handleHashChange();

        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);

    useEffect(() => {
        if (parameters.idFlight > 0) {
            handleGetFlight();
        }
    }, [parameters.idFlight]);
    useEffect(() => {

    }, []);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />} description={flight && flight.idFlightAODB > 0 ? `ID RMS ${flight.idFlightAODB}` : ""}>Editar vuelo {flight ? `ID #${flight.idFlight}` : ""}</Header>
                    {flight && flight.idFlight && flight.idAirportOrigin && (
                        <div style={{ maxWidth: 950 }}>
                            <Form actions={
                                <SpaceBetween size="m" direction='horizontal'>
                                    <Button variant="link" onClick={() => { window.location.hash = "#flights/grid"; }}>Cancelar</Button>
                                    <Button variant="primary" onClick={() => {
                                        console.log(flight);
                                        handleUpdateFlight();
                                    }}>Actualizar</Button>
                                </SpaceBetween>}>
                                <SpaceBetween size="m" direction='vertical'>
                                    <SpaceBetween size="m" direction='horizontal'>
                                        <div style={{ maxWidth: 400 }}>
                                            <Container>
                                                <div style={{ alignItems: "center" }}>
                                                    <SpaceBetween size="m" direction='horizontal'>
                                                        <div style={{ maxWidth: 200 }}>
                                                            <FormField label="Origen" constraintText={getAirport(flight.idAirportOrigin, data)?.city || flight.idAirportOrigin.toString()}>
                                                                <Link variant="awsui-value-large">{getAirport(flight.idAirportOrigin, data)?.IATA || "N/D"}</Link>
                                                            </FormField>
                                                        </div>
                                                        <div style={{ width: 120 }}>
                                                            <FormField label={flight.idAirportOrigin === flight.idAirportDestination ? <Icon path={mdiAirplaneLanding} size={1} /> : <Icon path={mdiAirplaneTakeoff} size={1} />}>
                                                                <Box textAlign="center">
                                                                    <div style={{ width: 120, alignItems: "center" }}>
                                                                        <Link variant="awsui-value-large">{flight.flightNumber}</Link>
                                                                        <img src={`https://fids-bucket.s3.us-east-1.amazonaws.com/media/images/airlines/fids/${flight.idAirline || 0}.png`} style={{ width: 120, height: "auto", border: "1px solid #ccc", borderRadius: "8px" }} />
                                                                    </div>
                                                                </Box>
                                                            </FormField>

                                                        </div>
                                                        <div style={{ maxWidth: 200 }}>
                                                            <FormField label="Destino" constraintText={getAirport(flight.idAirportDestination, data)?.city || flight.idAirportDestination.toString()}>
                                                                <Link variant="awsui-value-large">{getAirport(flight.idAirportDestination, data)?.IATA || "N/D"}</Link>
                                                            </FormField>
                                                        </div>
                                                    </SpaceBetween>
                                                </div>
                                            </Container>
                                        </div>

                                        <SpaceBetween size="m" direction='vertical'>
                                            <Box>
                                                <SpaceBetween size="m" direction='horizontal'>

                                                    <FormField label="Estado">
                                                        <SelectStatus single
                                                            filter={idAirport === flight.idAirportOrigin ? "DEP" : "ARR"}
                                                            value={flight.idStatus || 0}
                                                            onSelect={(status) => {
                                                                setFlight({ ...flight, idStatus: status || 0 });
                                                            }} />
                                                    </FormField>

                                                    {idAirport === flight.idAirportOrigin ? (
                                                        <FormField label="Puerta">
                                                            <SelectGate width={100} single value={flight.idGate || 0}
                                                                onSelect={(gate) => {
                                                                    setFlight({ ...flight, idGate: gate || 0 });
                                                                }} />
                                                        </FormField>
                                                    ) : (
                                                        <FormField label="Cinta">
                                                            <SelectBelt width={100} single value={flight.idBelt || 0}
                                                                onSelect={(belt) => {
                                                                    setFlight({ ...flight, idBelt: belt || 0 });
                                                                }} />
                                                        </FormField>
                                                    )}
                                                </SpaceBetween>
                                            </Box>
                                            <Box>
                                                {idAirport === flight.idAirportOrigin ? (
                                                    <SpaceBetween size="m" direction='vertical'>
                                                        <SpaceBetween size="m" direction='horizontal'>
                                                            <FormField label="Fecha salida" constraintText={getDate(flight.departureTime)}>
                                                                <DPModal width={120} date={getDate(flight.departureTimeReal)} onConfirm={(date) => {
                                                                    setFlight({ ...flight, departureTimeReal: date + ' ' + getTime(flight.departureTimeReal) });
                                                                }} />
                                                            </FormField>

                                                            <div style={{ width: 100 }}>
                                                                <FormField label="Hora" constraintText={getTime(flight.departureTime)}>
                                                                    <TimeInput format="hh:mm" value={getTime(flight.departureTimeReal)}
                                                                        onChange={(e) =>
                                                                            setFlight({ ...flight, departureTimeReal: getDate(flight.departureTimeReal) + ' ' + e.detail.value })} />
                                                                </FormField>
                                                            </div>
                                                        </SpaceBetween>

                                                        <SpaceBetween size="m" direction='horizontal'>
                                                            <FormField label="Fecha embarque" constraintText={getDate(flight.boardingTime)}>
                                                                <DPModal width={120} date={getDate(flight.boardingTimeReal)} onConfirm={(date) => {
                                                                    setFlight({ ...flight, boardingTimeReal: date + ' ' + getTime(flight.boardingTimeReal) });
                                                                }} />
                                                            </FormField>

                                                            <div style={{ width: 100 }}>
                                                                <FormField label="Hora" constraintText={getTime(flight.boardingTime)}>
                                                                    <TimeInput format="hh:mm" value={getTime(flight.boardingTimeReal)}
                                                                        onChange={(e) => setFlight({ ...flight, boardingTimeReal: getDate(flight.boardingTimeReal) + ' ' + e.detail.value })} />
                                                                </FormField>
                                                            </div>
                                                        </SpaceBetween>


                                                    </SpaceBetween>
                                                ) : (

                                                    <SpaceBetween size="m" direction='horizontal'>
                                                        <FormField label="Fecha llegada" constraintText={getDate(flight.arrivalTime)}>
                                                            <DPModal width={120} date={getDate(flight.arrivalTimeReal)} onConfirm={(date) => {
                                                                setFlight({ ...flight, arrivalTimeReal: date + ' ' + getTime(flight.arrivalTimeReal) });
                                                            }} />
                                                        </FormField>

                                                        <div style={{ width: 100 }}>
                                                            <FormField label="Hora llegada" constraintText={getTime(flight.arrivalTime)}>
                                                                <TimeInput format="hh:mm" value={getTime(flight.arrivalTimeReal)}
                                                                    onChange={(e) => setFlight({ ...flight, arrivalTimeReal: getDate(flight.arrivalTimeReal) + ' ' + e.detail.value })} />
                                                            </FormField>
                                                        </div>
                                                    </SpaceBetween>
                                                )}
                                            </Box>
                                        </SpaceBetween>
                                    </SpaceBetween>

                                    <SpaceBetween size="m" direction='horizontal'>


                                        <SpaceBetween size="m" direction='vertical'>
                                            <Box>

                                                <SpaceBetween size="m" direction='vertical'>

                                                    <div style={{ width: 300 }}>
                                                        <Checkbox description="Indica si el vuelo está activo y se despliega en FIDS" checked={flight.isActive === 1} onChange={e => {
                                                            setFlight({ ...flight, isActive: e.detail.checked ? 1 : 0 });
                                                        }}>Vuelo activo</Checkbox>
                                                    </div>
                                                    <div style={{ width: 300 }}>
                                                        <Checkbox description="Indica si el vuelo está cerrado y no se puede mostrar como arribado o despegado" checked={flight.isClosed === 1} onChange={e => {
                                                            setFlight({ ...flight, isClosed: e.detail.checked ? 1 : 0 });
                                                        }}>Vuelo cerrado</Checkbox>
                                                    </div>
                                                    <div style={{ width: 300 }}>
                                                        <Checkbox description="Vuelo ha sido cancelado y se autoriza a modificar el estado en CRON" checked={flight.isCancel === 1} onChange={e => {
                                                            setFlight({ ...flight, isCancel: e.detail.checked ? 1 : 0 });
                                                        }}>Vuelo cancelado</Checkbox>
                                                    </div>

                                                </SpaceBetween>

                                            </Box>
                                        </SpaceBetween>
                                        <SpaceBetween size="m" direction='vertical'>
                                            <Box>

                                                <SpaceBetween size="m" direction='vertical'>

                                                    <div style={{ width: 300 }}>
                                                        <Checkbox
                                                            disabled={flight.idFlightAODB == 0}

                                                            description="Indica si el vuelo recibe actualizaciones desde el RMS" checked={flight.isRMSEnabled === 1} onChange={e => {
                                                                setFlight({ ...flight, isRMSEnabled: e.detail.checked ? 1 : 0 });
                                                            }}>Conectividad RMS</Checkbox>
                                                    </div>
                                                    <div style={{ width: 300 }}>
                                                        <Checkbox description="Indica si el se actualiza el estado automáticamente" checked={flight.isStatusUpdate === 1} onChange={e => {
                                                            setFlight({ ...flight, isStatusUpdate: e.detail.checked ? 1 : 0 });
                                                        }}>Actualización automática</Checkbox>
                                                    </div>

                                                </SpaceBetween>

                                            </Box>
                                        </SpaceBetween>


                                    </SpaceBetween>






                                </SpaceBetween>
                            </Form>
                        </div>
                    )}
                </SpaceBetween>

            }
        />
    )
};
